import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate, Router } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { AssignmentComponent } from './assignments/assignment-create.component';
import { AssignmentsComponent } from './assignments/assignment-list.component';
import { ImportComponent } from './import/import.component';
import { RouterGuard } from './router.guard';
import { SlideshowComponent } from './slideshow/slideshow.component';
import { SlideComponent } from './slideshow/slide/slide.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageNotFoundComponent } from './dashboard/not-found.component';
import { UserCreateComponent } from './users/user-create.component';
import {UsersComponent} from './users/user-list.component';

const routes: Routes = [
    { 
        path: '',
        component: DashboardComponent,
        canActivate: [RouterGuard],
        children: [
            {
                path: 'assignment/create',
                component: AssignmentComponent,
                data: {
                    state: 'assignment/create',
                    roles: ['editor', 'administrator'],
                    title: 'Create Assignment'
                }
            },
            {
                path: 'assignment/create/quiz',
                component: AssignmentComponent,
                data: {
                    state: 'assignment/create/quiz',
                    roles: ['editor', 'administrator'],
                    title: 'Create Assignment'
                }
            },
            {
                path: 'import',
                component: ImportComponent,
                data: {
                    state: 'import',
                    roles: ['editor', 'administrator'],
                    title: 'Import Assignment',
                    limited: true
                }
            },
            {
                path: 'assignments/queue',
                component: AssignmentsComponent,
                data: {
                    state: 'queue',
                    title: 'My Queue'
                }
            },
            {
                path: 'assignments/sent-to-editor',
                component: AssignmentsComponent,
                data: {
                    state: 'sentToEditor',
                    title: 'Sent to Editor',
                    roles: ['editor', 'administrator']
                }
            },
            {
                path: 'assignments/assigned',
                component: AssignmentsComponent,
                data: {
                    state: 'assigned',
                    title: 'Assigned',
                    roles: ['editor', 'administrator']
                }
            },
            {
                path: 'assignments',
                component: AssignmentsComponent,
                data: {
                    state: 'assignments',
                    title: 'All Assignments',
                    roles: ['editor', 'administrator']
                }
            },
            {
                path: 'slideshow/:id',
                component: SlideshowComponent,
                data: {
                    state: 'slideshow',
                    title: 'Slideshow'
                },
                children: [
                    {
                        path: ':slide',
                        component: SlideComponent,
                        data: {
                            state: 'slide',
                            title: 'Slideshow'
                        }
                    }
                ]      
            },
            {
                path: 'users/create',
                component: UserCreateComponent,
                data: {
                    state: 'users/create',
                    roles: ['administrator'],
                    title: 'Create Users'
                }       
            },
            {
                path: 'users',
                component: UsersComponent,
                data: {
                    state: 'users',
                    roles: ['administrator'],
                    title: 'All Users'
                }
            }        
        ]
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutesModule {}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/app.routes.module.ts